import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, custom, shape }: Theme) => ({
  root: {
    padding: 13,
    borderRadius: shape.borderRadius,
    width: '100%',
    fontSize: 14,
    color: custom.grey[2],
    backgroundColor: custom.grey[8],
    display: 'flex',
  },
  iconContainer: {
    color: palette.primary.main,
    marginRight: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  strongContent: {
    color: custom.grey[3],
    lineHeight: '18px',
    fontWeight: 600,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
}));
